import { useCallback, useRef } from "react";

export const useDebounceCallback = (callback, delay) => {
  // ** Refs
  const timer = useRef(null);

  // ** Callback
  const debouncedCallback = useCallback(
    (...args) => {
      if (timer.current) {
        clearTimeout(timer.current);
      }

      timer.current = setTimeout(() => {
        callback(...args);
      }, delay);
    },
    [callback, delay]
  );

  return debouncedCallback;
};
